import { PayType } from "../models/PayType";
import { host, getRequest, patchRequest, postRequest, deleteRequest } from "./apiService";

export async function getPayTypes() {
	return getRequest<PayType[]>(`${host}/api/PayType`);
}
export async function updatePayType(payType: PayType) {
	return patchRequest<void>(
		`${host}/api/payType/${payType.id}`, payType
	);
}
export async function addPayType(newPayType: PayType) {
	const { id, ...objectWithoutId } = newPayType;
	return postRequest<PayType | undefined>(
		`${host}/api/payType`, objectWithoutId
	);
}
export async function deletePayType(id: number) {
	return deleteRequest(`${host}/api/payType/${id}`);
}